const data = [
	{
		Achievements: `Currently working as a domain coordinator for the newly introduced honors course
		“ Artificial Intelligence & Machine Learning” by SPPU
		`,
	},
	{
		Achievements: `Worked as a team Leader & coordinator for the syllabus setting of SPPU (2019 
			course)`,
	},
	{
		Achievements: `Received best paper award in the domain of data mining and information retrieval 
		at international conference, SKNCOE, Pune`,
	},
	{
		Achievements: `Many times received the appreciation for getting the outstanding result for the 
		subject taught (SPPU theory examination).
		`,
	},
	{
		Achievements: `My research paper “LFNN: Lion Fuzzy Neural Network based Evolutionary model for 
		Text Classification using Context and Sense based Features” is published in high 
		impact factor journal , Applied soft computing ,Science Citation Indexed journal `,
	},
	{
		Achievements: `My research paper “Automatic text classification using BPLion-neural network and 
		semantic word processing” is published in Imaging science journal, Science Citation 
		Indexed journal`,
	},
	{
		Achievements: `Recognized as a PG Teacher in Computer Engineering, SPPU, Pune`,
	},
	{
		Achievements: `Received research grant from BCUD to pursue my research project.
		`,
	},
	{
		Achievements: `Secured Elite category in four NPTEL courses (introduction to research, Teaching 
			methodology and Machine learning, Data Mining) conducted by IIT’s `,
	},
];

export default data;
